import { gql, useQuery } from '@apollo/client';

export const GET_DATEV_NUMBER_BY_ID = gql`
  query getDatevNumberById($datevNumberId: String!) {
    getDatevNumberById(datevNumberId: $datevNumberId) {
      _id
      datevNumber
      status
      details
      createdBy
    }
  }
`;

export const useGetDatevNumberById = (datevNumberId: string) => {
  const { data, loading } = useQuery(GET_DATEV_NUMBER_BY_ID, {
    variables: { datevNumberId },
    skip: !datevNumberId,
  });

  const datevNumber = data?.getDatevNumberById || {};

  return { datevNumber, loading };
};
